/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const intakeFormDefinitions = sqliteTable('intake_form_definitions', {
  id: text('id').primaryKey().notNull(),
  name: text('name'),
  status: text('status'),
  version: integer('version'),
  schema: text('schema'),
  validation_schema: text('validation_schema'),
});
